export default __webpack_public_path__ + "static/media/query-tech.7f1ed3f6.png";